import { Box, Stack } from '@mui/material';
import { selectedProjectSectionIdsQuery } from '../../../core/project/queries';
import { useAppSelector } from '../../../types';
import DispatchButton from '../../design_system/inputs/buttons/DispatchButton';

export const ActionsOnSelectedProjectSections = () => {
    const selectedIds = useAppSelector(selectedProjectSectionIdsQuery);

    return (
        <Stack sx={{ flexDirection: 'row', justifyContent: 'flex-end', m: 1.5 }}>
            {selectedIds.length > 0 ? (
                <Stack direction="row" gap={1}>
                    <DispatchButton title="projectList.edit_priority" modalType="PROJECT_SECTION_EDIT_PRIORITY" />
                    <DispatchButton
                        title="projectList.edit_repairSolution"
                        modalType="PROJECT_SECTION_EDIT_REPAIR_SOLUTION"
                    />
                    <DispatchButton title="projectList.edit_repairYear" modalType="PROJECT_SECTION_EDIT_REPAIR_YEAR" />
                    <DispatchButton
                        title="projectList.edit_repairFollowUp"
                        modalType="PROJECT_SECTION_EDIT_REPAIR_FOLLOW_UP"
                    />
                    <DispatchButton title="projectList.edit_assignee" modalType="PROJECT_SECTION_EDIT_ASSIGNEE" />
                </Stack>
            ) : (
                <Box sx={{ height: 40 }} />
            )}
        </Stack>
    );
};
